import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'nv-numbox',
  template: require('./nv-numbox.component.html'),
  styles: [require('./nv-numbox.scss')],
  encapsulation: ViewEncapsulation.None,
})
export class NvNumboxComponent implements OnInit {
  /**
   *
   */
  @Input() numControl: FormControl;

  /**
   *
   */
  @Input() type: 'number' | 'integer' = 'number';

  /**
   *
   */
  @Input() placeholder: string = 'Enter a number...';

  /**
   * Determines whether to show the clear button
   */
  @Input() hasClearBtn: boolean = false;

  /**
   *
   */
  @Input() icon: string;

  /**
   *
   */
  @Output() changeValue: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('input', { static: false }) inputElement: ElementRef;

  private debounce_time: number = 50; // millis
  private destroy$: Subject<boolean> = new Subject<boolean>();

  ngOnInit() {
    // Set up the subscription to Value Changes
    this.numControl.valueChanges
      .pipe(
        debounceTime(this.debounce_time),
        distinctUntilChanged(),
        takeUntil(this.destroy$),
      )
      .subscribe(query => this.onValueChange(query));
  }

  onValueChange(num_value: number): void {
    this.changeValue.emit(num_value);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
